export enum JobStatusFilter {
  ALL = "ALL",
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  DRAFT = "DRAFT",
}

export const getJobStatusDisplayText = (status: JobStatusFilter): string => {
  switch (status) {
    case JobStatusFilter.ALL:
      return "All";
    case JobStatusFilter.OPEN:
      return "Open";
    case JobStatusFilter.CLOSED:
      return "Closed";
    case JobStatusFilter.DRAFT:
      return "Draft";
    default:
      return status;
  }
};
